import type React from 'react';

import { observer } from 'mobx-react';

export interface IProps {
  open?: boolean;
  description: string;
}

const DescriptionItem: React.FC<IProps> = observer(({ description }) => {
  return (
    <>
      <div className="flex-none">
        <div className="w-5">
          <svg width={8} height={8}>
            <circle cx={4} cy={4} r={2} stroke="black" strokeWidth={1} fill="transparent" />
          </svg>
        </div>
      </div>
      <div className="flex-both">{description}</div>
    </>
  );
});

DescriptionItem.displayName = 'DescriptionItem';

export default DescriptionItem;
